import { CATEGORIES, SORT_OPTIONS } from '../data/constants'

/**
 * Sticky filter bar: category tabs + sort dropdown.
 * @param {{
 *   category: string,
 *   onCategory: (cat: string) => void,
 *   sort: string,
 *   onSort: (sort: string) => void,
 *   totalFiltered: number
 * }} props
 */
const Filters = ({ category, onCategory, sort, onSort, totalFiltered }) => (
  <div className="sticky top-[61px] z-40 bg-white/90 backdrop-blur-md border-b border-slate-100">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
      <div className="flex items-center justify-between gap-4 flex-wrap">

        {/* Category tabs */}
        <nav aria-label="Deal categories" className="flex items-center gap-2 overflow-x-auto scrollbar-hide pb-0.5">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => onCategory(cat)}
              aria-pressed={category === cat}
              className={`shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold
                transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400
                ${category === cat
                  ? 'bg-gradient-to-r from-brand-600 to-violet-600 text-white shadow-md shadow-brand-200'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
            >
              {cat}
            </button>
          ))}
        </nav>

        {/* Right side: count + sort */}
        <div className="flex items-center gap-3 shrink-0">
          <span className="hidden sm:block text-xs text-slate-400 font-medium">
            {totalFiltered} result{totalFiltered !== 1 ? 's' : ''}
          </span>

          <div className="flex items-center gap-2">
            <label htmlFor="sort-select" className="text-xs text-slate-500 font-medium hidden sm:block">
              Sort:
            </label>
            <select
              id="sort-select"
              value={sort}
              onChange={(e) => onSort(e.target.value)}
              className="text-sm font-semibold text-slate-700
                bg-slate-50 border border-slate-200 rounded-xl
                px-3 py-1.5 pr-8
                focus:outline-none focus:ring-2 focus:ring-brand-400
                cursor-pointer appearance-none
                bg-no-repeat bg-right"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
                backgroundPosition: 'right 10px center',
              }}
            >
              {SORT_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>
          </div>
        </div>

      </div>
    </div>
  </div>
)

export default Filters
